import { GameConstants } from "../../GameConstants";
import { RoadManager } from "./Roadmanager";
import { GameVars } from "../../GameVars";

export class ControlsInstructionsLayer extends Phaser.Group {

    public static currentInstance: ControlsInstructionsLayer = null;

    constructor(game: Phaser.Game) {

        super(game, null, "controls-instructions-layer");

        ControlsInstructionsLayer.currentInstance = this;

        const darkLayer = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        darkLayer.scale.set(GameConstants.GAME_WIDTH / GameConstants.BITMAP_SIZE, GameConstants.GAME_HEIGHT / GameConstants.BITMAP_SIZE);
        darkLayer.alpha = .65;
        darkLayer.inputEnabled = true;
        darkLayer.events.onInputDown.add(RoadManager.removeInstructionsLayer, RoadManager);
        this.add(darkLayer);

        const text = "Use the arrow keys (WASD) to move the chicken. \n\n Jump with 'space'.\n\n Save as many chicken as you can. \n\n May the chicken force be with you.";

        const instructionText = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, text, {font: "25px RoundsBlack", fill: "#FFFFFF", align: "center"});
        instructionText.anchor.set(.5);
        instructionText.scale.x = GameVars.scaleX;
        instructionText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
        this.add(instructionText);
    }

    public destroy(destroyChildren?: boolean, soft?: boolean): void {

        ControlsInstructionsLayer.currentInstance = null;

        super.destroy(destroyChildren, soft);
    }
}